import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import styled from '@mui/material/styles/styled';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Row from './Row';
import { sentenceCase } from '../../../../utils/utils';
import Title from '../../../elements/title/Title';
import NoContent from '../../../sections/no-content/NoContent';

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  marginTop: theme.spacing(2),
  minHeight: '257px',
}));

const BillingHistory = ({ billingData, handlePagination, downloadReceipt }) => {
  const { t } = useTranslation();

  const TABLE_HEADERS = [
    t('billing.number', { ns: 'project' }),
    t('billing.date', { ns: 'project' }),
    t('billing.description', { ns: 'project' }),
    t('billing.net', { ns: 'project' }),
    t('billing.tax', { ns: 'project' }),
    t('billing.total', { ns: 'project' }),
    t('billing.status', { ns: 'project' }),
  ];

  const handlePageChange = (event, page) => {
    handlePagination(page - 1);
  };

  return (
    <>
      <Title subTitle text={t('billingHistory', { ns: 'sectionTitles' })} />
      {billingData?.content?.length > 0 ? (
        <>
          <StyledTableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell />
                  {TABLE_HEADERS.map((header, i) => (
                    <TableCell align={i !== 0 ? 'center' : 'left'} key={header}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {billingData?.content.map((item, i) => (
                  <Row key={i} data={item} downloadReceipt={downloadReceipt} />
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
          <Box
            sx={{
              mt: 2,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Pagination
              count={billingData.totalPages}
              shape="rounded"
              onChange={handlePageChange}
            />
          </Box>
        </>
      ) : (
        <NoContent
          title={sentenceCase(
            t('empty', {
              ns: 'descriptions',
              text: t('billing.history', { ns: 'project' }),
            })
          )}
        />
      )}
    </>
  );
};

BillingHistory.propTypes = {
  billingData: PropTypes.object.isRequired,
  handlePagination: PropTypes.func.isRequired,
  downloadReceipt: PropTypes.func.isRequired,
};

export default BillingHistory;
